import { ActivatedUser, WhitelistUser } from "@interfaces/user";

interface RawData {
  data: {
    users: {
      username?: string | null;
      phone_number?: string | null;
      expiry?: number | null;
    }[] | null;
  }
}

export function transformActivatedUsers(raw: unknown): ActivatedUser[] {
  const data = (raw as RawData).data;

  return data.users?.map(user => ({
    username: user.username || null,
    phoneNumber: user.phone_number || null,
  })) || [];
}

export function transformWhitelistUsers(raw: unknown): WhitelistUser[] {
  const data = (raw as RawData).data;

  return data.users?.map(user => ({
    username: user.username || null,
    phoneNumber: user.phone_number || null,
    expiry: user.expiry || null,
  })) || [];
}

